import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLatestActiveProjectsOfUser } from '../services/getLatestActiveProjectsOfUser.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getProjectsActivityFilterCacheKey } from '../utils/getProjectsActivityFilterCacheKey';

export const loadLatestActiveProjectsOfUser = createAsyncThunk(
  'projects/loadLatestActiveProjectsOfUser',
  async (arg = {}, { getState }) => {
    const activeEmployerInfo =
      arg.activeEmployerInfo || selectUserActiveEmployerInfo(getState());
    const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

    const response = await getLatestActiveProjectsOfUser({
      activeEmployerInfo,
    });

    // A backend without includeRecordIds support still answers with the bare
    // projectIds array — normalize so either deploy order works.
    const { projectIds = [], recordProjectIds = [] } = Array.isArray(response)
      ? { projectIds: response }
      : response || {};

    return {
      cacheKey,
      projectIds,
      recordProjectIds,
    };
  },
  {
    condition: (arg = {}, { getState }) => {
      const state = getState();
      const activeEmployerInfo =
        arg.activeEmployerInfo || selectUserActiveEmployerInfo(state);
      const cacheKey = getProjectsActivityFilterCacheKey(activeEmployerInfo);

      if (!cacheKey) {
        return false;
      }

      const requestStatus =
        state.projects.latestUserActiveProjectIdsRequestStatusByEmployer?.[
          cacheKey
        ];

      if (requestStatus === 'pending') {
        return false;
      }

      if (arg.force || arg.shouldRefetch) {
        return true;
      }

      return requestStatus !== 'fulfilled';
    },
  }
);
